import type { CSSProperties, ReactElement } from 'react';

import type { TextController } from '@/presentation/widgets/PrimaryInputField';

import { DigitButton } from './DigitButton';
import { DIGIT_KEYBOARD_ITEMS, type DigitKeyboardItem } from './digitKeyboardItem';
import styles from './DigitKeyboard.module.css';

/**
 * Перенос
 * `lib/src/presentation/pages/verify_admin/widgets/digit_keyboard/digit_keyboard.dart`.
 */

/**
 * Умолчания конструктора из Dart. Они без `.w` — то есть в логических
 * пикселях; экран пин-кода передаёт свои, уже масштабированные (`54.w`,
 * `10.w`).
 */
const DEFAULT_DIGIT_SIZE = '54px';
const DEFAULT_SPACING = '10px';
const DEFAULT_CROSS_AXIS_COUNT = 3;

export interface DigitKeyboardProps {
  /** `TextEditingController` — общий с полем пин-кода. */
  readonly controller: TextController;
  /** Готовая CSS-длина стороны кнопки, например `wv(54)`. */
  readonly digitSize?: string;
  /**
   * Готовая CSS-длина. Участвует только в ширине контейнера: промежутки
   * самого Wrap в Dart заданы литералами, а не этим полем.
   */
  readonly spacing?: string;
  readonly crossAxisCount?: number;
}

/** Ключ списка: набор кнопок фиксирован и никогда не переставляется. */
function itemKey(item: DigitKeyboardItem): string {
  return item.kind === 'key' ? `key-${item.digit}` : item.kind;
}

export function DigitKeyboard({
  controller,
  digitSize = DEFAULT_DIGIT_SIZE,
  spacing = DEFAULT_SPACING,
  crossAxisCount = DEFAULT_CROSS_AXIS_COUNT,
}: DigitKeyboardProps): ReactElement {
  // `totalWidth`: crossAxisCount * (digitSize + spacing).
  const totalWidth = `calc(${crossAxisCount} * (${digitSize} + ${spacing}))`;
  return (
    <div className={styles.container}>
      <div
        className={styles.wrap}
        style={{ '--total-width': totalWidth } as CSSProperties}
      >
        {DIGIT_KEYBOARD_ITEMS.map((item) => (
          <DigitButton
            key={itemKey(item)}
            item={item}
            size={digitSize}
            controller={controller}
          />
        ))}
      </div>
    </div>
  );
}
